import { useEffect, useState } from 'react';
import { useGA } from '@/Hooks/useGA';
import { loadTenantConfig } from '@/services/tenantService';

const WhatsappFloatButton = () => {
  const { trackUserAction } = useGA();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const tenantConfig = await loadTenantConfig();
        setConfig(tenantConfig.FEATURE_FLAGS?.WHATSAPP_FLOAT || null);
      } catch (error) {
        console.error('Error fetching WhatsApp float config:', error);
        setConfig(null);
      }
    };

    fetchConfig();
  }, []);

  if (!config?.enabled || !config?.phone) {
    return null;
  }

  const href = `https://wa.me/${config.phone}${config.message ? `?text=${encodeURIComponent(config.message)}` : ''}`;

  const handleClick = () => {
    trackUserAction('click', 'interaction', 'whatsapp_float_button');
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label="Falar no WhatsApp"
      className="fixed bottom-24 right-4 lg:bottom-6 lg:right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg hover:brightness-95 transition-all"
    >
      <svg viewBox="0 0 32 32" width="30" height="30" fill="#FFFFFF" aria-hidden="true">
        <path d="M16.001 3C9.096 3 3.5 8.596 3.5 15.5c0 2.312.63 4.474 1.726 6.33L3 29l7.348-2.184A12.44 12.44 0 0 0 16.001 28C22.905 28 28.5 22.404 28.5 15.5S22.905 3 16.001 3Zm0 22.7a10.16 10.16 0 0 1-5.185-1.42l-.372-.221-4.36 1.296 1.317-4.25-.243-.386a10.16 10.16 0 0 1-1.558-5.419c0-5.634 4.586-10.22 10.401-10.22 5.815 0 10.401 4.586 10.401 10.22 0 5.634-4.586 10.4-10.401 10.4Zm5.723-7.634c-.313-.157-1.853-.914-2.14-1.018-.287-.104-.496-.157-.705.157-.209.313-.809 1.018-.992 1.226-.183.209-.365.235-.678.078-.313-.157-1.322-.487-2.518-1.552-.931-.83-1.56-1.854-1.743-2.167-.183-.313-.02-.482.137-.638.14-.14.313-.365.47-.548.157-.183.209-.313.313-.522.104-.209.052-.391-.026-.548-.078-.157-.705-1.7-.966-2.328-.254-.611-.512-.528-.705-.538l-.6-.011c-.209 0-.548.078-.835.391-.287.313-1.096 1.071-1.096 2.612 0 1.541 1.122 3.03 1.278 3.238.157.209 2.208 3.371 5.351 4.727.747.322 1.33.515 1.784.66.75.239 1.432.205 1.971.124.601-.09 1.853-.757 2.114-1.488.261-.73.261-1.357.183-1.488-.078-.13-.287-.209-.6-.365Z" />
      </svg>
    </a>
  );
};

export default WhatsappFloatButton;
